var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconFieldwellsOrderby(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.089,
    height: 15.252,
    viewBox: "0 0 21.089 15.252",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-sort-2393175",
    transform: "translate(-4.479 -4.495)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71130",
    "data-name": "Path 71130",
    d: "M23.68,5H6.377A1.347,1.347,0,0,0,5,6.311,1.347,1.347,0,0,0,6.377,7.626h17.3a1.388,1.388,0,0,0,1.208-.683A1.317,1.317,0,0,0,23.68,5Z",
    fill: "#202124",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71132",
    "data-name": "Path 71132",
    d: "M6.378,59.747h10.65a1.389,1.389,0,0,0,1.209-.684,1.318,1.318,0,0,0-1.209-1.948H6.378a1.317,1.317,0,1,0,0,2.632Z",
    transform: "translate(0 -40.503)",
    fill: "#202124",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71133",
    "data-name": "Path 71133",
    d: "M21.562,32.994a1.319,1.319,0,0,0-1.21-1.949H6.379a1.319,1.319,0,1,0,0,2.634H20.352A1.39,1.39,0,0,0,21.562,32.994Z",
    transform: "translate(0 -20.243)",
    fill: "#202124",
    stroke: "#fff",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFieldwellsOrderby);
export default __webpack_public_path__ + "static/media/icon-fieldwells-orderby.9c7a678f.svg";
export { ForwardRef as ReactComponent };